// source: PublicSpotKlineV3Api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.PublicSpotKlineV3Api', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PublicSpotKlineV3Api = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.PublicSpotKlineV3Api, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PublicSpotKlineV3Api.displayName = 'proto.PublicSpotKlineV3Api';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PublicSpotKlineV3Api.prototype.toObject = function(opt_includeInstance) {
  return proto.PublicSpotKlineV3Api.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PublicSpotKlineV3Api} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PublicSpotKlineV3Api.toObject = function(includeInstance, msg) {
  var f, obj = {
interval: jspb.Message.getFieldWithDefault(msg, 1, ""),
windowstart: jspb.Message.getFieldWithDefault(msg, 2, 0),
openingprice: jspb.Message.getFieldWithDefault(msg, 3, ""),
closingprice: jspb.Message.getFieldWithDefault(msg, 4, ""),
highestprice: jspb.Message.getFieldWithDefault(msg, 5, ""),
lowestprice: jspb.Message.getFieldWithDefault(msg, 6, ""),
volume: jspb.Message.getFieldWithDefault(msg, 7, ""),
amount: jspb.Message.getFieldWithDefault(msg, 8, ""),
windowend: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PublicSpotKlineV3Api}
 */
proto.PublicSpotKlineV3Api.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PublicSpotKlineV3Api;
  return proto.PublicSpotKlineV3Api.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PublicSpotKlineV3Api} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PublicSpotKlineV3Api}
 */
proto.PublicSpotKlineV3Api.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setInterval(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWindowstart(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setOpeningprice(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setClosingprice(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setHighestprice(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLowestprice(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setVolume(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAmount(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWindowend(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PublicSpotKlineV3Api.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PublicSpotKlineV3Api.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PublicSpotKlineV3Api} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PublicSpotKlineV3Api.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInterval();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWindowstart();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getOpeningprice();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getClosingprice();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getHighestprice();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLowestprice();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getVolume();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAmount();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getWindowend();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
};


/**
 * optional string interval = 1;
 * @return {string}
 */
proto.PublicSpotKlineV3Api.prototype.getInterval = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicSpotKlineV3Api} returns this
 */
proto.PublicSpotKlineV3Api.prototype.setInterval = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 windowStart = 2;
 * @return {number}
 */
proto.PublicSpotKlineV3Api.prototype.getWindowstart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.PublicSpotKlineV3Api} returns this
 */
proto.PublicSpotKlineV3Api.prototype.setWindowstart = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string openingPrice = 3;
 * @return {string}
 */
proto.PublicSpotKlineV3Api.prototype.getOpeningprice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicSpotKlineV3Api} returns this
 */
proto.PublicSpotKlineV3Api.prototype.setOpeningprice = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string closingPrice = 4;
 * @return {string}
 */
proto.PublicSpotKlineV3Api.prototype.getClosingprice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicSpotKlineV3Api} returns this
 */
proto.PublicSpotKlineV3Api.prototype.setClosingprice = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string highestPrice = 5;
 * @return {string}
 */
proto.PublicSpotKlineV3Api.prototype.getHighestprice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicSpotKlineV3Api} returns this
 */
proto.PublicSpotKlineV3Api.prototype.setHighestprice = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string lowestPrice = 6;
 * @return {string}
 */
proto.PublicSpotKlineV3Api.prototype.getLowestprice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicSpotKlineV3Api} returns this
 */
proto.PublicSpotKlineV3Api.prototype.setLowestprice = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string volume = 7;
 * @return {string}
 */
proto.PublicSpotKlineV3Api.prototype.getVolume = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicSpotKlineV3Api} returns this
 */
proto.PublicSpotKlineV3Api.prototype.setVolume = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string amount = 8;
 * @return {string}
 */
proto.PublicSpotKlineV3Api.prototype.getAmount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicSpotKlineV3Api} returns this
 */
proto.PublicSpotKlineV3Api.prototype.setAmount = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int64 windowEnd = 9;
 * @return {number}
 */
proto.PublicSpotKlineV3Api.prototype.getWindowend = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.PublicSpotKlineV3Api} returns this
 */
proto.PublicSpotKlineV3Api.prototype.setWindowend = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


goog.object.extend(exports, proto);
